import { json } from "react-router-dom";

class ApiServices {
    _apiBase = process.env.NODE_ENV === 'production' ? '/menu/api/' :'http://cocktail/delivery-app/api/';

    getResource = async (url, params = null) => {
        const res = await fetch(url, params);

        if (!res.ok) {
            throw new Response('', {stauts: res.status, statusText: "not found"});
        }
        return await res.json();
    }

    getCategories = async () => {
        const res = await this.getResource(`${this._apiBase}categories`);

        if (!res.length) {
            throw json({message: 'not found', reason: 'problem to fetch'}, {status: res.status})
        }

        return await res;
    }

    getLazyProducts = async (offset = 0) => {
        console.log(offset);
        const res = await this.getResource(`${this._apiBase}lazy-products?offset=${offset}`);

        return await res;
    }

    getProductsByCategories = async () => {
        const res = await this.getResource(`${this._apiBase}products`);
        return await res;
    }

    showMoreProducts = async (id, offset) => {
        const res = await this.getResource(`${this._apiBase}load-more/${id}/${offset}`);
        return await res;
    }

    getProductsById = async (id) => {
        const res = await this.getResource(`${this._apiBase}product/${id}`);
        return await res;
    }
    
    addToCart = async (data)  => {
        const res = await this.getResource(`${this._apiBase}cart/add`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cartId: data.cartId,
                productId: data.productId
            })
        });

        return await res;
    }

    updateCartItem = async (data) => {
        const res = await this.getResource(`${this._apiBase}cart/update`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                cartId: data.cartId,
                productId: data.productId,
                qty: data.qty
            })
        });

        return await res;
    }

    getCart = async (cartId) => {      
        if (!cartId)
        {
            return []
        }

        const res = await this.getResource(`${this._apiBase}cart`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cartId: cartId,
            })
        })
        return await res;
    }

    getSchedule = async () => {
        const res = await this.getResource(`${this._apiBase}cart/schedule`)

        return await res;
    }

    getSearchResult = async (query) => {
        if(query.trim().length === 0) {
            return []
        }

        const res = await this.getResource(`${this._apiBase}search/${query}`);

        return await res;
    }

    getAboutCompany = async () => {
        const res = await this.getResource(`${this._apiBase}about-info`);

        return await res;
    }

    getSettings = async () => {
        const res = await this.getResource(`${this._apiBase}settings`);

        return await res;
    }

    getLiqPayData = async (cartId) => {
        const res = await this.getResource(`${this._apiBase}liqpay`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                orderId: cartId
            })
        });

        return await res;
    }

    createOrder = async () => {
        const cartId = localStorage.getItem('cartId');
        const shipping = JSON.parse(localStorage.getItem('shipping'));
        const payment = localStorage.getItem('payment');

        const res = await this.getResource(`${this._apiBase}create-order`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cartId: cartId,
                shipping: shipping,
                payment: payment,
            })
        });

        return await res;
    }

    auth = async (user) => {
        const res = this.getResource(`${this._apiBase}user/auth`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: user
            })
        });

        return await res;
    }

    addUser = async (shipping) => {

        const res = await this.getResource(`${this._apiBase}user`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: shipping
            })
        });

        return await res;
    }

    getUser = async (user) => {
        const res = await this.getResource(`${this._apiBase}user/current`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user: user
            })
        });

        return res;
    }

    getHistory = async (data) => {
        const query = data.query !== null ? `/${data.query}` : '';
        const user = data.customer;

        const res = await this.getResource(`${this._apiBase}history${query}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user
            })
        });


        return await res;
    }

    addLike = async (data) => {
        const res = await this.getResource(`${this._apiBase}like`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: data.customer,
                product: data.id,
            })
        });

        return await res;
    }

    getLikes = async (user) => {
        const res = await this.getResource(`${this._apiBase}user/likes`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: user
            })
        });

        return await res;
    }
}

export default ApiServices;